<template>
  <div>
    <vs-popup :title="$t('CreateSerial')" :active.sync="showModal">
      <div class="vx-row px-8">
        <vs-button
          type="filled"
          class="w-5/12 ml-12"
          :class="isShowIncrease ? 'opacity-50' : ''"
          @click.prevent="showDeductionDisrepancy()"
        >
          {{ $t("DeductionDisrepancy") }}</vs-button
        >
        <vs-button
          type="filled"
          class="w-5/12 mr-12"
          :class="isShowIncrease ? '' : 'opacity-50'"
          @click.prevent="showIncreaseDisrepancy()"
          >{{ $t("IncreaseDisrepancy") }}</vs-button
        >
      </div>

      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('Serial') },
              { title: $t('GroupName') },
              { title: $t('Zone') }
            ]"
          >
            <template slot-scope="{ row }">
              <td style="width: 80%" v-if="!isShowIncrease">
                {{ row.serial }}
              </td>
              <td style="width: 40%" v-if="isShowIncrease">
                {{ row.serial }}
              </td>
              <td style="width: 40%" v-if="isShowIncrease">
                {{ row.countingGroupInfo ? row.countingGroupInfo.name : "---" }}
              </td>
              <td style="width: 40%" v-if="isShowIncrease">
                {{ row.countingGroupInfo ? row.countingGroupInfo.zone : "---" }}
              </td>
            </template>
          </data-grid>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import DataGrid from "@/components/datagrid/DataGrid";
export default {
  name: "",
  props: {
    show: { default: false },
    stockTakingId: { default: "" },
    countTagId: { default: "" }
  },
  components: {
    DataGrid
  },
  data() {
    return {
      isShowIncrease: false,
      manualUrlService: "",
      gridDataSource: { data: [] },
      gridSearchData: {}
    };
  },

  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
        this.$validator.reset();
      }
    }
  },
  methods: {
    showDeductionDisrepancy() {
      this.isShowIncrease = false;
      this.manualUrlService =
        "Inventory/api/CountingTagQuery/" +
        this.countTagId +
        "/contradiction/deductions";

      this.gridDataSource = { type: "app", service: this.manualUrlService };
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 500);
    },
    showIncreaseDisrepancy() {
      this.isShowIncrease = true;
      this.manualUrlService =
        "Inventory/api/CountingTagQuery/" +
        this.countTagId +
        "/contradiction/increases";

      this.gridDataSource = { type: "app", service: this.manualUrlService };
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 500);
    }
  },
  watch: {
    show() {
      if (this.show) {
        this.showDeductionDisrepancy();
      }
    }
  }
};
</script>
